<template>
  <div>
    <el-card>
      <el-form size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="6">
            <!--发车转运中心-->
            <el-form-item :label="$t('routes.departureTransferCenter')">
              <el-select
                v-model="queryForm.params.departTransferCenterId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in flowDirectNextList"
                  :key="item.siteId"
                  :label="item.siteName"
                  :value="item.siteId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--下一站流向-->
            <el-form-item :label="$t('routes.下一站流向')">
              <el-select
                v-model="queryForm.params.nextSiteId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in flowDirectNextList"
                  :key="item.siteId"
                  :label="item.siteName"
                  :value="item.siteId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--发车时间-->
            <el-form-item :label="$t('routes.发车时间')">
              <el-date-picker
                v-model="timeValue"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('operationCenter.endDate')"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :start-placeholder="$t('operationCenter.startDate')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div>
              <el-button size="small" type="primary" @click="getTableData">{{ $t('collectionCenter.search') }}</el-button>
              <el-button size="small" plain @click="resetSearch">{{ $t('collectionCenter.reset') }}</el-button>
              <el-radio-group
                v-model="queryForm.params.formalOrTest"
                size="small"
                style="margin-left: 10px"
                @change="getTableData()"
              >
                <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
                <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button>
              </el-radio-group>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <el-button size="small" type="primary" @click="exportData">{{ $t('collectionCenter.export') }}</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background:'#f2f2f2',color:'black', textAlign:'center' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            type="selection"
            width="50"
            fixed="left"
          />
          <el-table-column
            :label="$t('GlobalSetObj.serial')"
            align="center"
            type="index"
            width="80"
            fixed="left"
          />
          <el-table-column
            v-for="(item, index) in tableColumn"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            :align="item.align"
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'bagQuantity'">
                <div :style="{ color: scope.row['bagQuantity'] < scope.row['shouldBagQuantity'] ? 'red' : '' }">
                  {{ scope.row[item.prop] }}
                </div>
              </div>
              <div v-else-if="item.prop === 'normalQuantity'">
                <div :style="{ color: scope.row['normalQuantity'] < scope.row['shouldNormalQuantity'] ? 'red' : '' }">
                  {{ scope.row[item.prop] }}
                </div>
              </div>
              <div v-else-if="item.prop === 'bigPieceQuantity'">
                <div :style="{ color: scope.row['bigPieceQuantity'] < scope.row['shouldBigPieceQuantity'] ? 'red' : '' }">
                  {{ scope.row[item.prop] }}
                </div>
              </div>
              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('GlobalSetObj.operate')" align="center" fixed="right">
            <template slot-scope="scope">
              <!--编辑-->
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('GlobalSetObj.details')"
                placement="top"
              >
                <el-button size="mini" type="text" @click="openAddEditWindow(scope.row)">
                  <i class="el-icon-document" style="font-size: 20px;" />
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 50, 100, 200, 400]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 20px 0; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
    <el-drawer
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('GlobalSetObj.SenderDetails')"
      :visible.sync="isAddEditWindow"
      direction="ltr"
      size="800px"
    >
      <div style="height: calc(100vh - 130px);overflow-y: auto;">
        <addEdit
          ref="addEditWindow"
          :key="isAddEditWindow"
          :edit-row="editRow"
        />
      </div>
      <div style="text-align: right;padding: 10px;border-top: 1px solid #ccc">
        <el-button size="small" @click="isAddEditWindow = false">{{ $t('GlobalSetObj.close') }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import dayjs from 'dayjs';
// import { getSiteTransfer } from '@/api/orderApi';
import { getSiteAndTransfer } from '@/api/newExpressAPI';
import addEdit from './cmp/addEdit.vue';
import { getOrderWaybillDaily, getOrderWaybillDailyExport } from '@/api/logisticsOrders';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ShouldSendDataMonitoring',
  components: {
    addEdit
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          departTransferCenterId: '',
          nextSiteId: '',
          formalOrTest: 1
        }
      },
      timeValue: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      // transferList: [],
      tableData: [],
      tableColumn: [
        // 发车时间
        { label: this.$t('routes.发车时间'), prop: 'departureTime', align: 'center', width: '150' },
        // 流向名称
        { label: this.$t('routes.flowName'), prop: 'flowDirectName', align: 'center', width: '150' },
        // 发车转运中心
        { label: this.$t('routes.departureTransferCenter'), prop: 'departTransferCenterName', align: 'center', width: '150' },
        // 下一站流向
        { label: this.$t('routes.下一站流向'), prop: 'nextSiteName', align: 'center', width: '150' },
        // 应发件时间范围
        { label: this.$t('routes.DepartureTimeRange'), prop: 'shipmentTimeScope', align: 'center', width: '150' },
        // 应发袋数
        { label: this.$t('routes.NumberBagsSent'), prop: 'shouldBagQuantity', align: 'center', width: '150' },
        // 应发件数（正常）
        { label: this.$t('routes.NumberItemsToBeSent') + '(' + this.$t('placeOrder.Normal') + ')', prop: 'shouldNormalQuantity', align: 'center', width: '150' },
        // 应发件数（大件）
        { label: this.$t('routes.NumberItemsToBeSent') + '(' + this.$t('placeOrder.big01') + ')', prop: 'shouldBigPieceQuantity', align: 'center', width: '150' },
        // 已发袋数
        { label: this.$t('routes.NumberOfSentBags'), prop: 'bagQuantity', align: 'center', width: '150' },
        // 已发件数（正常）
        { label: this.$t('routes.NumberOfSentItems') + '(' + this.$t('placeOrder.Normal') + ')', prop: 'normalQuantity', align: 'center', width: '150' },
        // 已发件数（大件）
        { label: this.$t('routes.NumberOfSentItems') + '(' + this.$t('placeOrder.big01') + ')', prop: 'bigPieceQuantity', align: 'center', width: '150' }
      ],
      total: 0,
      isAddEditWindow: false,
      flowDirectNextList: [],
      editRow: null,
      selectedData: []
    };
  },
  created() {
    this.initTime();
    // this.getSiteTransfer();
    this.getTableData();
    this.getFlowDirectNameList();
  },
  methods: {
    // 列表数据勾选
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    // 获取下一站流向名称
    getFlowDirectNameList() {
      getSiteAndTransfer().then((res) => {
        if (res.code === 200) {
          this.flowDirectNextList = res.data;
        }
      });
    },
    // 打开新增编辑弹窗
    openAddEditWindow(row) {
      this.editRow = row;
      this.isAddEditWindow = true;
    },
    // 导出
    exportData() {
      if (!this.timeValue || this.timeValue.length < 2) {
        this.$message.warning(this.$t('routes.PleaseSelectDepartureTime'));
        return;
      }
      const params = this.getQueryParams().params;
      params.shipmentIdList = this.selectedData.map(item => item.id);
      getOrderWaybillDailyExport(params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 初始化时间
    initTime() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD'); // 获取当前日期
      const threeDaysAgo = dayjs(brazilTime).subtract(0, 'day').format('YYYY-MM-DD'); // 三天前日期
      this.timeValue = [threeDaysAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    // 获取转运中心
    // getSiteTransfer() {
    //   getSiteTransfer().then((res) => {
    //     if (res.code === 200) {
    //       this.transferList = res.data;
    //     }
    //   });
    // },
    // 请求参数整理
    getQueryParams() {
      const { pageNumber, pageSize, params } = this.queryForm;
      const queryParams = {
        pageNumber,
        pageSize,
        params: {
          departTransferCenterId: params.departTransferCenterId,
          nextSiteId: params.nextSiteId,
          departureTimeStart: '',
          departureTimeEnd: '',
          formalOrTest: params.formalOrTest
        }
      };
      if (this.timeValue && this.timeValue.length > 0) {
        queryParams.params.departureTimeStart = this.timeValue[0];
        queryParams.params.departureTimeEnd = this.timeValue[1];
      }
      return queryParams;
    },
    // 获取列表数据
    getTableData() {
      if (!this.timeValue || this.timeValue.length < 2) {
        this.$message.warning(this.$t('routes.PleaseSelectDepartureTime'));
        return;
      }
      const params = this.getQueryParams();
      getOrderWaybillDaily(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 重置搜索条件
    resetSearch() {
      this.queryForm.params = {
        departTransferCenterId: '',
        nextSiteId: '',
        formalOrTest: 1
      };
      this.initTime();
      this.getTableData();
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>

<style scoped>

</style>
